import { render, staticRenderFns } from "./modalRespostas.vue?vue&type=template&id=9e19b65a&scoped=true"
import script from "./modalRespostas.vue?vue&type=script&lang=js"
export * from "./modalRespostas.vue?vue&type=script&lang=js"
import style0 from "./modalRespostas.vue?vue&type=style&index=0&id=9e19b65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e19b65a",
  null
  
)

export default component.exports